module.exports = __webpack_public_path__ + "img/40_38_045_940.460d2fbd.jpg";